function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0.75 4.1875H20.25C20.6642 4.1875 21 3.85173 21 3.4375V1.5625C21 1.14827 20.6642 0.8125 20.25 0.8125H0.75C0.335766 0.8125 0 1.14827 0 1.5625V3.4375C0 3.85173 0.335766 4.1875 0.75 4.1875ZM0.75 11.6875H20.25C20.6642 11.6875 21 11.3517 21 10.9375V9.0625C21 8.64827 20.6642 8.3125 20.25 8.3125H0.75C0.335766 8.3125 0 8.64827 0 9.0625V10.9375C0 11.3517 0.335766 11.6875 0.75 11.6875ZM0.75 19.1875H20.25C20.6642 19.1875 21 18.8517 21 18.4375V16.5625C21 16.1483 20.6642 15.8125 20.25 15.8125H0.75C0.335766 15.8125 0 16.1483 0 16.5625V18.4375C0 18.8517 0.335766 19.1875 0.75 19.1875Z",
  fill: "white"
});

var SvgMenu = function SvgMenu(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Menu.44f3d401.svg";
export { ForwardRef as ReactComponent };